import { CertificacionesMaestroModel } from "@/store/catalogos/certificacionesMaestro.model";
import { ColaboradorModel } from "@/store/catalogos/colaborador.model";
import { DocumentModel } from "@/store/document.model";

import { properties } from "@/utils/properties";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ColaboradorService {
  constructor(private http: HttpClient) {}


  getFotoColaborador(tabla: string, idTabla: number): Observable<any> {
    return this.http.get<any>(
      `${properties.URL_CATALOGS}archivos/buscar/${tabla}/${idTabla}`,
      properties.httpOptions,
    );
  }

  getDocuments(data: CertificacionesMaestroModel): Observable<DocumentModel[]> {
    return this.http.post<DocumentModel[]>(
      properties.URL_CATALOGS + "colaborador/documentos",
      data,
      properties.httpOptions,
    );
  }
}
